import type { Timeout } from 'ahooks/lib/useRequest/src/types';
import type { RefObject } from 'react';
import { useEffect, useRef, useState } from 'react';

export const useIsScrolling = (scrollRef: RefObject<HTMLDivElement>) => {
  const [mask, setMask] = useState(false);
  const inScrollTimer = useRef<Timeout | null>(null);

  useEffect(() => {
    if (!scrollRef.current) return;

    const onScroll = () => {
      requestAnimationFrame(() => {
        inScrollTimer.current && clearTimeout(inScrollTimer.current);
        setMask(true);
        inScrollTimer.current = setTimeout(() => {
          setMask(false);
        }, 200);
      });
    };

    scrollRef.current.addEventListener('scroll', onScroll);

    const clear = () => {
      scrollRef.current?.removeEventListener('scroll', onScroll);
    };

    return clear;
  }, [scrollRef]);

  return mask;
};
